import React, { useState, useEffect } from 'react';
import useFetchPrices from '../hooks/useFetchPrices';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api'; // Adjust based on your API utility file

const PriceList = () => {
  const { token } = useAuth(); // Get the token from context
  const { data: prices, loading, error } = useFetchPrices();
  const [editablePrices, setEditablePrices] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (prices && prices.length > 0) {
      // Initialize editable prices
      setEditablePrices(prices[0]);
    }
  }, [prices]);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditablePrices((prevPrices) => ({
      ...prevPrices,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      await api.put(`/prices/${editablePrices._id}`, editablePrices, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setIsEditing(false); // Exit edit mode
      // Optionally, refetch prices or update local state here
    } catch (err) {
      console.error('Error updating price:', err);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error fetching prices: {error.message}</p>;

  return (
    <>
      <h1 className="text-2xl font-bold mb-4">Prices</h1>
      {isEditing ? (
        <div className="bg-white shadow-md rounded p-4">
          <h2 className="text-xl font-semibold mb-4">Edit Prices</h2>
          <div className="mb-4">
            <label className="block mb-1">
              PS:
              <input
                type="number"
                name="PS"
                value={editablePrices.PS || ''}
                onChange={handleChange}
                className="border border-gray-300 rounded p-2 w-full"
              />
            </label>
          </div>
          <div className="mb-4">
            <label className="block mb-1">
              XB:
              <input
                type="number"
                name="XB"
                value={editablePrices.XB || ''}
                onChange={handleChange}
                className="border border-gray-300 rounded p-2 w-full"
              />
            </label>
          </div>
          <div className="mb-4">
            <label className="block mb-1">
              PC:
              <input
                type="number"
                name="PC"
                value={editablePrices.PC || ''}
                onChange={handleChange}
                className="border border-gray-300 rounded p-2 w-full"
              />
            </label>
          </div>
          <div className="flex gap-4">
            <button onClick={handleSave} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
              Save
            </button>
            <button onClick={() => setIsEditing(false)} className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400">
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div className="bg-white shadow-md rounded p-4">
          <p className="mb-2">PS: ${prices[0]?.PS}</p>
          <p className="mb-2">XB: ${prices[0]?.XB}</p>
          <p className="mb-4">PC: ${prices[0]?.PC}</p>
          <button onClick={handleEdit} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
            Edit Prices
          </button>
        </div>
      )}
    </>
  );

};

export default PriceList;
